import { ChannelType } from './enums/channel-type';
import { FaillureType } from './enums/faillure-type';

export class MailConnectorError {
    id: number;
    taskId: string;
    filePath: string;
    date: Date;
    faillureType: FaillureType;
    organizationId: string;
    channelId: number;
    channelType: ChannelType;
    mailFromAddress: string;
    mailToAddresses: string;
    mailSubject: string;
    mailBody: string;
    mailAttachmentsCount: number;

    public createCopy(): MailConnectorError {
        const instance = new MailConnectorError();
        instance.id = this.id;
        instance.taskId = this.taskId;
        instance.filePath = this.filePath;
        instance.date = this.date;
        instance.faillureType = this.faillureType;
        instance.channelId = this.channelId;
        instance.channelType = this.channelType;
        instance.organizationId = this.organizationId;
        instance.mailFromAddress = this.mailFromAddress;
        instance.mailToAddresses = this.mailToAddresses;
        instance.mailSubject = this.mailSubject;
        instance.mailBody = this.mailBody;
        instance.mailAttachmentsCount = this.mailAttachmentsCount;
        return instance;
    }

    public copyFrom(other: any) {
        this.id = other.id;
        this.taskId = other.taskId;
        this.filePath = other.filePath;
        this.date = other.date;
        this.faillureType = other.faillureType;
        this.channelId = other.channelId;
        this.channelType = other.channelType;
        this.organizationId = other.organizationId;
        this.mailFromAddress = other.mailFromAddress;
        this.mailToAddresses = other.mailToAddresses;
        this.mailSubject = other.mailSubject;
        this.mailBody = other.mailBody;
        this.mailAttachmentsCount = other.mailAttachmentsCount;
    }
}
